import { useMutation, useQueryClient } from "@tanstack/react-query";
import { siteWizardQuery } from "../../../../../../hooks/useSiteWizard";
import type { components } from "../../../../../../types/api.types";
import urls from "../../../../../../urls";
import { useUploadVollmacht } from "./useUploadVollmacht";
import { vollmachtVermarkterFilesQueries } from "./useVollmachtVermarkterFiles";

export type VermarkterVollmachtUploadSuccess =
  components["schemas"]["VermarkterVollmachtUploadSuccess"];

function useUploadVollmachtVermarkter(siteId: number) {
  const { uploadVollmacht } =
    useUploadVollmacht<VermarkterVollmachtUploadSuccess>(siteId, {
      uploadUrl: urls.api.uploadVermarkterVollmachtFile
    });
  const queryClient = useQueryClient();

  const uploadVollmachtVermarkterMutation = useMutation({
    mutationFn: ({ files, personId }: { files: File[]; personId: number }) =>
      uploadVollmacht(files, { person: personId }),
    onSettled() {
      queryClient.invalidateQueries(
        vollmachtVermarkterFilesQueries.bySiteId(siteId)
      );
      queryClient.invalidateQueries(siteWizardQuery(siteId));
    }
  });

  return { uploadVollmachtVermarkterMutation };
}

export { useUploadVollmachtVermarkter };
